import Page from '../PublicPage';
import { LockOpenOutlined } from '@mui/icons-material';
import useForm from 'pages/components/Form/useForm';
import FormFields from 'pages/components/FormFields';
import { Grid2 } from '@mui/material';
import { FormFieldsConfig } from 'pages/components/Form/FormEntities';
import { useTranslation } from 'react-i18next';
import { LoginRequest } from 'Domain/User/Dto/LoginRequest';
import { LoginUser } from 'Application/User/LoginService';
import {
  getRoute,
  FORGOT_PASSWORD,
  REGISTER,
} from 'Infrastructure/config/routesConfig';

export default function Login() {
  return (
    <Page
      title={'PUBLIC.title_login'}
      icon={<LockOpenOutlined fontSize="inherit" />}
      links={getFooterLinks()}
    >
      <LoginForm />
    </Page>
  );
}
function getFooterLinks() {
  return [
    {
      label: 'PUBLIC.link_lost_password',
      url: getRoute(FORGOT_PASSWORD),
    },
    {
      label: 'PUBLIC.link_not_member_yet',
      url: getRoute(REGISTER),
    },
  ];
}

function LoginForm() {
  const { t } = useTranslation();
  function handleSubmit(e: any) {
    e.preventDefault();
    if (isValidForm()) {
      LoginUser(getLoginRequest(values));
    }
  }

  const LoginFormConfig: FormFieldsConfig = {
    email: {
      constraints: ['email', 'required'],
    },
    password: {
      constraints: ['required'],
    },
    rememberMe: {
      default: false,
    },
  };

  const {
    errors,
    values,
    isValidForm,
    formatErrorObject,
    handleInputChange,
    Form,
  } = useForm(LoginFormConfig, true);

  return (
    <Form onSubmit={handleSubmit}>
      <Grid2 display={'grid'} gridTemplateColumns={'1fr'} gap={2}>
        <FormFields.Email
          autoFocus
          name="email"
          value={values.email}
          onChange={handleInputChange}
          required
          {...formatErrorObject(errors.email)}
        />
        <FormFields.Password
          name="password"
          value={values.password}
          onChange={handleInputChange}
          type="password"
          required
          {...formatErrorObject(errors.password)}
        />

        <FormFields.CheckBox
          name="rememberMe"
          value={values.rememberMe}
          onChange={handleInputChange}
        />
      </Grid2>
      <FormFields.Button
        type="submit"
        label={t('FORM.SUBMIT.login')}
        fullWidth
        sx={{ mt: 2 }}
      />
    </Form>
  );
}

function getLoginRequest(values: any) {
  return new LoginRequest(values.email, values.password, values.rememberMe);
}
